<template>
  <div class="notice-bar">
    <IconFont :name="icon" /><p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: "noticeBar",
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.notice-bar {
  font-size: 14px; color: #ee7116; background: #fffbe8; display: flex; padding: 8px 15px;
  p { margin-left: 10px;}
}
</style>